import React from 'react';
import useAuth from '../../hooks/useAuth';

const AnonymousUser = (props) => {
  const { createdBy } = props;
  const { storeUserTenant, userRoles } = useAuth();

  const {isEntelligence} = userRoles;
  const userTenant = createdBy?.tenantGuid;

  if (!userTenant) return null;

  return (
    <span>
      {(storeUserTenant == userTenant)  || isEntelligence  ?   `${createdBy?.firstName} ${createdBy?.lastName}` : 'Anonymous'}
    </span>
  );
};

export default AnonymousUser;
